import React from "react";

const ListDesign = ({ listitems }) => {
  const heading = listitems?.heading;
  const para = listitems?.para;
  const subheading = listitems?.subheading;
  const items = listitems?.items || [];

  return (
    <>
      <div className="container my-5" id="procedure">
        <div className="row justify-content-center text-center">
          <div className="col-12 col-md-10">
            {heading && <h2 className="fw-bold mb-3 title">{heading}</h2>}
            {subheading && <h5 className="mt-3">{subheading}</h5>}
            {para && <p className="text-muted">{para}</p>}
          </div>
        </div>
      </div>

      <div className="row row-cols-1 row-cols-md-2 g-4 mx-auto">
        {items?.map((item, index) => (
          <div className="d-flex flex-column" key={index}>
            <div className="d-flex align-items-center">
              <div
                className="d-flex align-items-center justify-content-center rounded-circle me-3 flex-shrink-0"
                style={{
                  width: "40px",
                  height: "40px",
                  backgroundColor: "#f9f5e8",
                  color: "#c69933",
                }}
              >
                <i
                  className={item.icon}
                  style={{
                    fontSize: "16px",
                  }}
                ></i>
              </div>
              <h5 className="fw-bold mb-0">{item.title}</h5>
            </div>
            <p className="text-muted">{item.desc || item.description}</p>
          </div>
        ))}
      </div>
    </>
  );
};

export default ListDesign;
